import theme from '../Theme';

const styles = (materialTheme) => ({
  backgroundImage: {
    width: '100%',
    height: 'auto',
    borderRadius: '0px',
    [materialTheme.breakpoints.up('sm')]: {
      borderRadius: '16px',
      height: '192px',
    },
    objectFit: 'cover',
    objectPosition: 'center',
  },
  image: {
    objectFit: 'cover',
    objectPosition: 'center',
    height: '80px',
    position: 'absolute',
    display: 'block',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    margin: 'auto',
    border: 'solid 0.3rem',
    borderRadius: '0px',
    backgroundColor: '#ccc',
    borderColor: theme.colors.contrastText,
    [materialTheme.breakpoints.up('sm')]: {
      borderRadius: '16px',
      height: '140px',
    },
  },
  closedOverlay: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: 0,
    bottom: 0,
    bgcolor: 'rgba(54, 54, 54, 0.65)',
    borderRadius: 0,

    [materialTheme.breakpoints.up('sm')]: {
      borderRadius: 2,
    },
  },
  priceIcon: {
    color: materialTheme.palette.primary.dark,
    marginLeft: '5px',
    marginRight: '5px',
    width: '10px',
    height: '10px',
  },
  starIcon: {
    color: theme.colors.warning50,
    width: '18px',
    height: '18px',
  },
  orderTypeContainer: {
    backgroundColor: theme.colors.dark11,
  },
  favoriteIcon: {
    color: theme.colors.lightText2,
    width: '32px',
    height: '32px',
  },
  activeFavoriteIcon: {
    color: theme.colors.error,
    width: '32px',
    height: '32px',
  },
});

export default styles;
